import store from 'public/store'
import bus from 'public/utils/bus'
import { MessageBox } from 'element-ui'
import { http } from 'public/utils/http'
import { getToken } from 'public/utils'

// 判断当前用户是否需要正常登陆退出
const isNormalLoginOut = async () => {
  const res = await http('urm.user.clockOut', { accessToken: getToken() })
  return !res || !res.dump
}

export async function authChange (data) {
  const isOut = await isNormalLoginOut()
  if (isOut) return
  // urm 强制退出
  // business 员工信息组织变更，权限回收
  let time = 30
  let interval = setInterval(() => {
    time -= 1
    const dom = document.body.querySelector('.el-message-box.public-permission-change .el-message-box__message label')
    if (dom) {
      dom.innerText = time + '秒'
    }
    if (time === 0) {
      window.clearInterval(interval)
      interval = null
      store.dispatch('logout')
    }
  }, 1 * 1000)
  const msg = data.moduleName === 'urm' ? '系统权限' : '员工信息'
  const title = data.moduleName === 'urm' ? '权限变更' : '信息变更'
  MessageBox.confirm(`您的${msg}发生变更，系统将在<label style="color:#FF5555;">30秒</label>后自动退出，请重新登录系统！`, title, {
    dangerouslyUseHTMLString: true,
    customClass: 'public-permission-change',
    confirmButtonText: '我知道了',
    cancelButtonText: '立即退出',
    confirmButtonClass: 'primary',
    cancelButtonClass: 'text',
    showClose: false
  }).then(action => {
    window.clearInterval(interval)
    interval = null
    // t.$message.warning('权限变更，请重新登录')
  }).catch(_ => {
    store.dispatch('logout')
  })
}

export function moduleUpgradeLog (data) {
  const content = data.content
  if (!content || !content.id) {
    return
  }
  bus.$emit('GLOBAL_MODULE_LOG', content)
}

// 退出提醒上报
async function exitReminderReport (id, operationType) {
  try {
    await http('cts.urm.clockout.info', [{
      id,
      operationType
    }], { appkey: 50030 })
  } catch (error) {
    console.error('退出提醒上报失败', error)
  }
}

let globalIntervalOut = null // 使用全局定义，便于异常场景清除定时器
function clearGlobalIntervalOut () {
  window.clearInterval(globalIntervalOut)
  globalIntervalOut = null
}
// 下班打卡退出
export async function attendanceOutFunc (data) {
  if (globalIntervalOut) return
  // 前端判断是否需要弹出提示弹窗, countdown: 分钟单位
  const isOut = await isNormalLoginOut()
  let { countdown, uid } = data.content || {}
  if (isOut || !countdown) return
  countdown = countdown ? Number(countdown) : 3
  let time = countdown * 60 // countdown分钟后退出
  globalIntervalOut = setInterval(function () {
    time -= 1
    if (time === 0) {
      clearGlobalIntervalOut()
      store.dispatch('logout')
    }
  }, 1000)
  const msg = `检测您已打下班卡，为了维护公司信息安全，系统将在<label style="color:#FF5555;font-weight:bold;">${countdown}分钟</label>后自动退出！`
  const title = '铸剑退出提醒'
  MessageBox.confirm(msg, title, {
    dangerouslyUseHTMLString: true,
    customClass: 'public-permission-change',
    confirmButtonText: '我知道了',
    cancelButtonText: '立即退出',
    confirmButtonClass: 'primary',
    cancelButtonClass: 'text',
    showClose: false
  }).then(action => {
    exitReminderReport(uid, 1)
  }).catch(async (error) => {
    console.error('立即退出', error)
    clearGlobalIntervalOut()
    await exitReminderReport(uid, 2)
    store.dispatch('logout')
  })
}

// 重新登录要清除定时器
bus.$on('GLOBAL_LOGOUT', () => {
  clearGlobalIntervalOut()
})



// WEBPACK FOOTER //
// ./src/layout/layout/websocket-func.js